exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox[data-v-33e7b7e8]{top:5px}", ""]);

// exports
